import { Outlet, useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { savafAppOrigin, savafAppUrl } from '@/configs/app-url';

const APP_ROUTE_PREFIXES = ['/login', '/callback', '/admin', '/org'] as const;

const isAppRoute = (pathname: string): boolean =>
  APP_ROUTE_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const RootLayout = () => {
  const { pathname } = useLocation();
  const currentPath = window.location.pathname as `/${string}`;
  const redirectUrl =
    window.location.origin !== savafAppOrigin && isAppRoute(pathname)
      ? savafAppUrl(`${currentPath}${window.location.search}${window.location.hash}`)
      : undefined;

  useEffect(() => {
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }, [redirectUrl]);

  if (redirectUrl) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Redirecting to SavaF...</p>
      </div>
    );
  }

  return <Outlet />;
};
